import React, { PropsWithChildren } from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { MessageWithTooltipProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import SimpleTooltip from "../tooltips/tooltip";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const MessageWithTooltip: React.FC<PropsWithChildren<MessageWithTooltipProps>> = ({ children, toolTip }) => {
  return (
    <Grid container direction="row" className={cssExports.messageWithTooltip} columnGap={0.5}>
      <Grid item>{children}</Grid>
      <Grid item>
        <SimpleTooltip text={toolTip}>
          <div className={cssExports.tooltipIcon}>
            <Icon icon={IconDefinitionConstants.WInfo} />
          </div>
        </SimpleTooltip>
      </Grid>
    </Grid>
  );
};

export default MessageWithTooltip;
